import CardWithArrow from "@components/BasicComponents/Cards/CardWithArrow/CardWithArrow"
import Separator from "@components/CustomTypography/Separator/Separator"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./WorkshpoCardsSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const WorkshpoCardsSection = (props: Props) => {
	return (
		<Separator className={styles.cardContainer}>
			{props.data.mainContent?.map(
				(element: AdvancedSideAssetMainContent, index: number) => {
					return (
						<CardWithArrow
							key={index}
							className={styles.cardBox}
							data={element}
							id={index}
							withWhiteBackground
							withImage={false}
						/>
					)
				},
			)}
		</Separator>
	)
}

export default WorkshpoCardsSection
